import { render, staticRenderFns } from "./tdnav.vue?vue&type=template&id=01adaae4"
import script from "./tdnav.vue?vue&type=script&lang=js"
export * from "./tdnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports